import Cookies from "js-cookie";
import API from "./API";
import TenantAPI from "./TenantAPI";

export default class ConversationAPI {
  static async searchConversations(Query: Record<string, any>) {
    return API._bearerRequest(
      "post",
      `/tenant/conversations/search`,
      { Query },
      Cookies.get(`authenticationToken_${TenantAPI.getCurrentTenant()}`)
    );
  }
}
